import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import CurrentBankUsageChart from '../charts/CurrentBankUsage/CurrentBankUsageChart';
import CurrentBankUsagePrivateChart from '../charts/CurrentBankUsage/CurrentBankUsagePrivateChart';
import CurrentBankUsageMainAndMiddleChart from '../charts/CurrentBankUsage/CurrentBankUsageMainAndMiddleChart';
import CurrentBankUsageGranularChart from '../charts/CurrentBankUsage/CurrentBankUsageGranularCharts';
import CurrentBankUsagePPTX from '../powerpoint/CurrentBankUsagePPTX';
import axios from 'axios';
import { provinces, local_market, province_market_map } from '../constants';

const CurrentBankUsage = ({ heading, total, total_youth, total_private, prestige, private_only, youth, middle_market, mass_market }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState(''); 
  const [localMarkets, setLocalMarkets] = useState([]);
  const [chartsToDisplay, setChartsToDisplay] = useState('total-display');
  const [ChartDataMain, setChartDataMain] = useState([]);
  const [ChartDataPrivate, setChartDataPrivate] = useState([]);
  const [ChartDataYouthAndMiddle, setChartDataYouthAndMiddle] = useState([]);
  const [CurrentBankUsageDataPrestigeOnly, setCurrentBankUsageDataPrestigeOnly] = useState([]);
  const [CurrentBankUsageDataPrivateOnly, setCurrentBankUsageDataPrivateOnly] = useState([]);
  const [CurrentBankUsageDataYouthOnly, setCurrentBankUsageDataYouthOnly] = useState([]);
  const [CurrentBankUsageDataMassMarketOnly, setCurrentBankUsageDataMassMarketOnly] = useState([]);
  const [CurrentBankUsageDataMiddleMarketOnly, setCurrentBankUsageDataMiddleMarketOnly] = useState([]);

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);
    
    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]); 
    }
    setSelectedLocalMarket(''); 
  };


  const getProvinceValue = () => {
    return selectedProvince ? provinces[selectedProvince] : ''; 
  };

  const getLocalMarketValue = () => {
    return selectedLocalMarket ? local_market[selectedLocalMarket] : ''; 
  };

  // useEffect(() => {
  //   const fetchDataMain = async () => {
  //     try {
  //       const provinceValue = getProvinceValue();
  //       const localMarketValue = getLocalMarketValue();

  //       const response = await axios.get('http://localhost:8000/api/current_bank_usage/total/', {
  //         params: {
  //           province: provinceValue,
  //           local_market: localMarketValue,
  //         },
  //       });
  //       setChartDataMain(response.data.chart_data); 
  //     } catch (error) {
  //       console.error('Error fetching data for main data:', error);
  //       setChartDataMain([]); 
  //     }
  //   };
  //   fetchDataMain();
  // }, [selectedProvince, selectedLocalMarket]);


  // useEffect(() => {
  //   const fetchDataPrivate = async () => {
  //     try {
  //       const provinceValue = getProvinceValue();
  //       const localMarketValue = getLocalMarketValue();

  //       const response = await axios.get('http://localhost:8000/api/current_bank_usage/private/', {
  //         params: {
  //           province: provinceValue,
  //           local_market: localMarketValue,
  //         },
  //       });
  //       setChartDataPrivate(response.data.chart_data); 
  //     } catch (error) {
  //       console.error('Error fetching data for private data:', error);
  //       setChartDataPrivate([]); 
  //     }
  //   };
  //   fetchDataPrivate();
  // }, [selectedProvince, selectedLocalMarket]);

  // useEffect(() => {
  //   const fetchDataYouthAndMiddle = async () => {
  //     try {
  //       const provinceValue = getProvinceValue();
  //       const localMarketValue = getLocalMarketValue();

  //       const response = await axios.get('http://localhost:8000/api/current_bank_usage/youth_main_and_middle/', {
  //         params: {
  //           province: provinceValue,
  //           local_market: localMarketValue,
  //         },
  //       });
  //       setChartDataYouthAndMiddle(response.data.chart_data); 
  //     } catch (error) {
  //       console.error('Error fetching data for youth and middle data:', error);
  //       setChartDataYouthAndMiddle([]); 
  //     }
  //   };
  //   fetchDataYouthAndMiddle();
  // }, [selectedProvince, selectedLocalMarket]);

  useEffect(() => {
    const fetchData = async () => {
      const provinceValue = getProvinceValue();
      const localMarketValue = getLocalMarketValue();
  
      const endpointMapping = [
        { endpoint: 'total', setter: setChartDataMain },
        { endpoint: 'total_private', setter: setChartDataPrivate },
        { endpoint: 'youth_main_and_middle', setter: setChartDataYouthAndMiddle },
        { endpoint: 'youth', setter: setCurrentBankUsageDataYouthOnly },
        { endpoint: 'mass_market', setter: setCurrentBankUsageDataMiddleMarketOnly },
        { endpoint: 'middle_market', setter: setCurrentBankUsageDataMassMarketOnly },
        { endpoint: 'prestige', setter: setCurrentBankUsageDataPrestigeOnly },
        { endpoint: 'private', setter: setCurrentBankUsageDataPrivateOnly }
      ];
  
      try {
        const promises = endpointMapping.map(({ endpoint }) =>
          axios.get(`https://outlook.plus94research.co.za/api/current_bank_usage/${endpoint}/`, {
            params: {
              province: provinceValue,
              local_market: localMarketValue,
            },
          })
        );
  
        const responses = await Promise.all(promises);
        responses.forEach((response, index) => {
          endpointMapping[index].setter(response.data.chart_data);
        });
  
        console.log("All data fetched successfully");
      } catch (error) {
        console.error('Error fetching data:', error);
        endpointMapping.forEach(({ setter }) => setter([]));
      }
    };
  
    fetchData();
  }, [selectedProvince, selectedLocalMarket]);

  const handleChartDisplayChange = (displayType) => {
    setChartsToDisplay(displayType);
  };
  

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='three-charts-heading-div'>
        <h2 className='heading'>{heading}</h2>
      </div>

 

      <div className='filter'>

          <label htmlFor="province-select">Province: </label>

          <select
            id="province-select"
            value={selectedProvince}
            onChange={handleProvinceChange}
          >
            <option value="">All</option>
            {Object.keys(provinces).map((province) => (        // Object.keys() returns an array of the keys
              <option key={province} value={province}>
                {province}
              </option>
            ))}
          </select>


          
          <label htmlFor="local-market-select">Local Market: </label>


          <select
            id="local-market-select"
            value={selectedLocalMarket}
            onChange={(e) => setSelectedLocalMarket(e.target.value)}
            disabled={!selectedProvince || localMarkets.length === 0}
          >
            <option value="">All</option>
            {localMarkets.map((market, index) => (
              <option key={index} value={market}>
                {market}
              </option>
            ))}
        </select>
      </div>

      <div>
          <CurrentBankUsagePPTX
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            maindata={ChartDataMain}
            privatedata={ChartDataPrivate}
            youthdata={ChartDataYouthAndMiddle}
          />
      </div>

      {/* <div className='three-charts-container'>

     
        <div className='three-charts-left-container'>
            <h2 className='main-bank-total'>{total}</h2>
            <CurrentBankUsageChart
              selectedProvince={selectedProvince}
              selectedLocalMarket={selectedLocalMarket}
              mainData={ChartDataMain}
            />
        </div>

        <div className='three-charts-right-container'>
          <div>
              <h2 className='main-bank-total-private'>{total_youth}</h2>
              <CurrentBankUsageMainAndMiddleChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                youthData={ChartDataYouthAndMiddle}
              />
          </div>
          <div>      
              <h2 className='main-bank-total-youth'>{total_private}</h2>
              <CurrentBankUsagePrivateChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                privateData={ChartDataPrivate}
              />
          </div>
        </div>
        
      </div> */}

      
<div className='three-charts-container'>
        <div className='three-charts-left-container'>
          <h2 className='main-bank-total'>{total}</h2>
          <CurrentBankUsageChart
            selectedProvince={selectedProvince}
            selectedLocalMarket={selectedLocalMarket}
            mainData={ChartDataMain}
          />
        </div>

        {chartsToDisplay === "total-display" && (
          <div className='three-charts-right-container'>
            <div className='total-youth-mass-and-middle'>
              <h2 
                className='main-bank-total-youth' 
                onClick={() => handleChartDisplayChange('youth-mass-and-middle-only')}
                style={{ cursor: 'pointer' }}
              >
                {total_youth}
              </h2>
              <CurrentBankUsageMainAndMiddleChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                youthData={ChartDataYouthAndMiddle}
              />
            </div>

            <div className='total-private'>
              <h2 
                className='main-bank-total-private'
                onClick={() => handleChartDisplayChange('private-and-prestige')}
                style={{ cursor: 'pointer' }}
              >
                {total_private}
              </h2>
              <CurrentBankUsagePrivateChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                privateData={ChartDataPrivate}
              />
            </div>
          </div>
        )}

        {chartsToDisplay === "private-and-prestige" && (
          <div className='private-and-prestige-only'>
            <div>
              <h2 className='prestige-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{prestige}</h2>
              <CurrentBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={CurrentBankUsageDataPrestigeOnly}
                id="prestige-only"
              />
            </div>
            <div>
              <h2 className='private-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{private_only}</h2>
              <CurrentBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={CurrentBankUsageDataPrivateOnly}
                id="private-only"
              />
            </div>
          </div>
        )}

        {chartsToDisplay === "youth-mass-and-middle-only" && (
          <div className='youth-mass-and-middle-only'>
            <div>
              <h2 className='youth-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{youth}</h2>
              <CurrentBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={CurrentBankUsageDataYouthOnly}
                id="youth-only"
              />
            </div>
            <div>
              <h2 className='mass-market-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{mass_market}</h2>
              <CurrentBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={CurrentBankUsageDataMassMarketOnly}
                id="mass-market-only"
              />
            </div>
            <div>
              <h2 className='middle-market-only' onClick={() => handleChartDisplayChange('total-display')} style={{ cursor: 'pointer' }}>{middle_market}</h2>
              <CurrentBankUsageGranularChart
                selectedProvince={selectedProvince}
                selectedLocalMarket={selectedLocalMarket}
                data={CurrentBankUsageDataMiddleMarketOnly}
                id="middle-market-only"
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CurrentBankUsage;



